export enum DISABILITY_STATUS {
  hasDisabilityApproval06 = '06',
  hasDisabilityApproval14 = '14',
}

export enum CONTACT_TYPES_ID {
  home = 1,
  mobile = 3,
  email = 10,
}
